export const renameKey = (array: [], old_key: string, new_key: string) => {
  let newArray = [];
  // Check if old key = new key
  if (old_key !== new_key) {
    array.map((obj, index) => {
      //       Object.defineProperty(
      //         obj,
      //         new_key,
      //         Object.getOwnPropertyDescriptor(obj, old_key)
      //       );
      //       delete obj[old_key];
      obj[new_key] = obj[old_key];
      delete obj[old_key];
      newArray.push(obj);
      return newArray;
    });
  }
  return newArray;
};
